import NoAccess from './NoAccess';

export default NoAccess;



// WEBPACK FOOTER //
// ./src/views/NoAccess/index.js